var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("head-nav", { attrs: { menuItems: _vm.menuItems } }),
      _vm._v(" "),
      _c("div", { staticClass: "seg-content general" }, [
        _c(
          "section",
          { staticClass: "teacher-list" },
          _vm._l(_vm.items, function(item, ii) {
            return _c(
              "div",
              { staticClass: "teacher hl-wid ww1 wh1 wt0" },
              [
                _c("div", { staticClass: "img" }, [
                  _c("div", [
                    item.media
                      ? _c("img", {
                          attrs: {
                            src: _vm.photoLinkR(item.media, 400, 400, "Fit")
                          }
                        })
                      : _vm._e()
                  ]),
                  _c("span", [
                    item.media
                      ? _c("img", {
                          attrs: {
                            src: _vm.photoLinkR(item.media, 400, 400, "Fit")
                          }
                        })
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "details" }, [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        item.pubname || item.firstname + " " + item.lastname
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("router-link", {
                  staticClass: "wlink",
                  attrs: {
                    to: {
                      name: "content.teacher",
                      params: { id: item.username }
                    }
                  }
                })
              ],
              1
            )
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }